import React, { useState, useCallback, useEffect } from 'react';
import { EditorState, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { stateToHTML } from 'draft-js-export-html';
import htmlToDraft from 'html-to-draftjs';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { useTranslation } from 'react-i18next';

interface TextEditorProps {
  initialValue?: string;
  onSendEditorContent?: (content: string) => void;
}

const TextEditor: React.FC<TextEditorProps> = ({ initialValue, onSendEditorContent }) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const {t} = useTranslation();

  // If initial value is provided, convert it to EditorState
  useEffect(() => {
    if (initialValue) {
      const contentBlock = htmlToDraft(initialValue);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(newEditorState);
      }
    }
  }, [initialValue]);

  const onEditorStateChange = useCallback((newEditorState: EditorState) => {
    setEditorState(newEditorState);
  }, []);

  const handleSendContent = () => {
    const htmlContent = stateToHTML(editorState.getCurrentContent());
    if (onSendEditorContent) {
      onSendEditorContent(htmlContent);
    }
  };

  return (
    <div className="editor-container">
      <Editor
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        placeholder={t('write_here')}
      />
      <button
        type="button"
        onClick={handleSendContent}
        className="block mt-4 px-4 py-2 bg-Black text-white rounded"
      >
        {t("save_content")}
      </button>
    </div>
  );
};

export default TextEditor;
